<template>
  <div class="card">
    <div class="card-body">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              v-for="(organizer, index) in localOrganizers"
              :key="'organizer' + index"
              :label="'Организатор ' + (index + 1)"
            >
              <!-- Главный организатор -->
              <div class="organizer__main">
                <b-form-radio
                  v-model="localMainOrganizerIndex"
                  :value="index"
                  name="mainOrganizer"
                  class="mb-2"
                >
                  Главный организатор
                </b-form-radio>
              </div>

              <!-- Поиск организатора -->
              <div class="organizer-search mb-1">
                <b-form-input
                  v-model="searchQueries[index]"
                  placeholder="Поиск организатора..."
                  autocomplete="off"
                  @input="(val) => onSearchOrganizer(val, index)"
                  @blur="hideDropdown(index)"
                />
                <b-list-group
                  v-if="searchResults[index] && searchResults[index].length"
                  class="organizer-search__dropdown"
                >
                  <b-list-group-item
                    v-for="result in searchResults[index]"
                    :key="result.id"
                    button
                    @mousedown.prevent="onSelectOrganizer(result, index)"
                  >
                    {{ result.name }}
                  </b-list-group-item>
                </b-list-group>
              </div>

              <div class="organizer">
                Фото организатора
                <div class="upload-wrap">
                  <file-uploader
                    :key="organizer.id || index"
                    :default="organizer.photo"
                    :value="organizer.photo_id"
                    @input="val => (organizer.photo_id = val)"
                  />
                </div>

                <div class="organizer__wrap">
                  <!-- Удалить организатора -->
                  <svg
                    width="16"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="minus"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="svg-inline--fa fa-minus fa-w-14"
                    @click="removeOrganizer(index)"
                  >
                    <path
                      d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                    />
                  </svg>

                  <!-- Имя -->
                  <b-form-input
                    v-model="organizer.name"
                    class="organizer__input"
                    placeholder="Имя организатора"
                  />

                  <!-- Телефон -->
                  <b-form-input
                    v-model="organizer.phone"
                    class="organizer__input"
                    placeholder="Телефон"
                  />

                  <!-- Мессенджеры -->
                  <div class="organizer__switch">
                    <b-card-text class="mb-0">
                      WhatsApp
                    </b-card-text>
                    <b-form-checkbox
                      v-model="organizer.messengers"
                      class="custom-control-primary"
                      value="WA"
                      switch
                    />
                  </div>

                  <div class="organizer__switch">
                    <b-card-text class="mb-0">
                      Telegram
                    </b-card-text>
                    <b-form-checkbox
                      v-model="organizer.messengers"
                      class="custom-control-primary"
                      value="TG"
                      switch
                    />
                  </div>

                  <div class="organizer__switch">
                    <b-card-text class="mb-0">
                      Viber
                    </b-card-text>
                    <b-form-checkbox
                      v-model="organizer.messengers"
                      class="custom-control-primary"
                      value="VB"
                      switch
                    />
                  </div>
                </div>

                <!-- Соц. сети -->
                <div class="mt-2">
                  Соц. сети

                  <div
                    v-for="(link, sIdx) in (organizer.social_networks || [])"
                    :key="'org-social' + sIdx"
                    class="links"
                  >
                    <!-- удалить -->
                    <svg
                      width="16"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="minus"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      class="svg-inline--fa fa-minus fa-w-14"
                      @click="(organizer.social_networks = organizer.social_networks || []).splice(sIdx, 1)"
                    >
                      <path
                        d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                      />
                    </svg>

                    <b-form-input
                      v-model="link.url"
                      class="links__input"
                      placeholder="Ссылка на соц. сеть"
                    />
                    <b-form-input
                      v-model="link.code"
                      class="links__input"
                      placeholder="Код соц. сети"
                    />

                    <!-- справка -->
                    <svg
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      v-b-popover.html.hover.bottom="popoverHtml"
                      width="20"
                      class="ml-1 icon--universal"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="question"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                    >
                      <path
                        d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                      />
                    </svg>
                  </div>

                  <b-button
                    variant="primary"
                    class="mt-1"
                    @click="
                      (organizer.social_networks = organizer.social_networks || []).push({ code: null, url: null })
                    "
                  >
                    Добавить соц. сеть
                  </b-button>
                </div>
              </div>
            </b-form-group>

            <!-- Добавить организатора -->
            <b-button
              variant="primary"
              class="mr-1"
              @click="addOrganizer"
            >
              Добавить организатора
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BCardText,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'

import FileUploader from '@/global-components/FileUploader.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  findDuplicateOrganizerIndexes,
  getOrganizerDuplicateKey,
} from './organizersValidation'

export default {
  name: 'OrganizersStartSection',

  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormRadio,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    FileUploader,
  },

  directives: {
    'b-popover': {},
    ripple: {},
  },

  props: {
    organizers: { type: Array, required: true, default: () => [] },
    mainOrganizerIndex: { type: Number, required: true, default: 0 },
  },

  data() {
    return {
      searchResults: {},
      searchQueries: {},
      searchTimers: {},
    }
  },

  computed: {
    localOrganizers: {
      get() {
        return this.organizers
      },
      set(val) {
        this.$emit('update:organizers', val)
      },
    },
    localMainOrganizerIndex: {
      get() {
        return this.mainOrganizerIndex
      },
      set(val) {
        this.$emit('update:mainOrganizerIndex', val)
      },
    },
    popoverHtml() {
      return `
        Instagram - instagram<br>
        Telegram - telegram<br>
        VK - vk<br>
        <a href='https://fontawesome.com/v4.7/icons/'>Посмотреть все коды</a>
      `
    },
  },

  methods: {
    onSearchOrganizer(query, index) {
      if (this.searchTimers[index]) clearTimeout(this.searchTimers[index])
      if (!query || query.length < 2) {
        this.$set(this.searchResults, index, [])
        return
      }
      this.searchTimers[index] = setTimeout(async () => {
        try {
          const { data } = await this.$http.get('organizer/dropdown', {
            params: { filterText: query },
          })
          const selectedIds = new Set(
            this.localOrganizers
              .map((org, i) => (i === index ? null : getOrganizerDuplicateKey(org)))
              .filter(Boolean),
          )
          const rows = (data.rows || []).filter(row => {
            const key = getOrganizerDuplicateKey({ organizer_id: row.id })
            return !selectedIds.has(key)
          })
          this.$set(this.searchResults, index, rows)
        } catch (e) {
          this.$set(this.searchResults, index, [])
        }
      }, 300)
    },

    onSelectOrganizer(selected, index) {
      if (!selected) return
      const selectedKey = getOrganizerDuplicateKey({ organizer_id: selected.id })
      const alreadyUsed = this.localOrganizers.some((org, i) => {
        if (i === index) return false
        return getOrganizerDuplicateKey(org) === selectedKey
      })
      if (alreadyUsed) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'AlertTriangleIcon',
            text: 'Этот организатор уже добавлен к старту',
            variant: 'danger',
          },
        })
        this.$set(this.searchResults, index, [])
        return
      }
      const updated = this.localOrganizers.map((org, i) => {
        if (i !== index) return org
        return {
          ...org,
          organizer_id: selected.id,
          name: selected.name || org.name,
          phone: selected.phone || org.phone,
          social_networks: selected.social_networks && selected.social_networks.length
            ? selected.social_networks.map(sn => ({ code: sn.code, url: sn.url }))
            : org.social_networks,
          photo: selected.photo || org.photo,
          photo_id: selected.photo ? selected.photo.id : org.photo_id,
        }
      })
      this.localOrganizers = updated
      this.$set(this.searchResults, index, [])
      this.$set(this.searchQueries, index, '')
      this.warnIfDuplicates()
    },

    warnIfDuplicates() {
      const duplicates = findDuplicateOrganizerIndexes(this.localOrganizers)
      if (!duplicates.length) return
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Ошибка',
          icon: 'AlertTriangleIcon',
          text: `В списке есть одинаковые организаторы (позиции: ${duplicates.map(i => i + 1).join(', ')})`,
          variant: 'danger',
        },
      })
    },

    hideDropdown(index) {
      this.$set(this.searchResults, index, [])
    },

    addOrganizer() {
      this.localOrganizers = [
        ...this.localOrganizers,
        {
          name: null,
          phone: null,
          messengers: [],
          social_networks: [{ code: null, url: null }],
        },
      ]

      if (this.localOrganizers.length === 1) {
        this.localMainOrganizerIndex = 0
      }
    },
    removeOrganizer(index) {
      this.localOrganizers.splice(index, 1)
      if (this.localMainOrganizerIndex >= this.localOrganizers.length) {
        this.localMainOrganizerIndex = 0
      }
    },
  },
}
</script>
<style lang="scss">
.fa-minus,
.icon--universal {
  path {
    fill: #b4b7bd;
  }
}

.links {
  display: flex;
  align-items: center;

  svg {
    transition: 0.3s;

    &:hover {
      cursor: pointer;
      transform: scale(1.3);
    }
  }

  &__input {
    margin: 10px 0;

    &:nth-child(2) {
      margin: 10px 10px;
    }
  }
}

.organizer {
  &__wrap {
    display: flex;

    input {
      margin: 0 10px;
    }
  }

  &__switch {
    margin: 0 10px;
  }
}

.upload-wrap {
  margin-bottom: 20px;
}

.organizer-search {
  position: relative;

  &__dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 100;
    max-height: 220px;
    overflow-y: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

</style>
